module.exports = __webpack_public_path__ + "images/paper-add.1790221230673.png";